/*{"ResultStatus":false,"ResultObject":[],"ResultObjectEx":"","ErrorList":["Please enter URL to the textbox below."]}*/


export enum e_DemoType {
    None = 0,
    FreeTrial  = 1,
    Demo  = 2
}

export interface Result {
    resultStatus: boolean,
    resultObject: object,
    resultObjectEx: object
    errorList: string[]
}

export interface Response {
    statusCode: number,
    data: Result
}
export interface ProductsRelDocs {
    nodeGUID: string,
    nodeID: number,
    optionName: string,
    optionOrder: number,
    categoryDisplayName: string,
    documentName: string,
    parentSKUNumber: string,
    skuParentSKUID: number,
    skuid: number,
    msrp: number,
    skuPrice: number,
    couponCode: string,
    couponPrice: number,
    couponCampaignID: number,
    couponStripeHTML: string,
    discount: number,
    shortName: string,
    productID: number,
    icon: string,
    preview: string,
    thumb: string,
    mainOrder: number,
    documentPageDescription: string,
    documentUrlPath: string,
    skuEnabled: boolean,
    note: string,
    saleEndDate: string,
    skuNumber: string,
    skuName: string,
    isPreorder: boolean,
    isInventory: boolean,
    departmentID: number,
    reviewsTotal: number,
    rating: number,
    demoType: e_DemoType,
    upgrades: boolean,
    gsfCategory: string,
    manualPDF: string,
    splititMinTotal: number,
    variantsMinimalPrice: boolean,
    isProductOptions: boolean,
    numberOfLessons: number,
    courseDurationHours: number,
    numberOfPlugins: number,
    upgradeTargetID: number,
    includedInSBS: number,
    addToCartStatus: number,

    isWishlist: boolean,
    freeForWCA?: boolean,

    minPrice?: number|string, // string === 'fake'
    fixedPosition?: string,

    withCouponEnabled?: boolean,
    isProductVisible?: boolean,
    isSamePrice?: boolean,
    expectedShipping?: string|null,
    isProductFadeOut?: boolean,
    isVisible?: boolean,
    title?: string,

    bannerAbove: string
}
